import React from 'react'
import SeriesList from '../Components/SeriesList';

const Series = () => {
  return (
    <div>
      <SeriesList />
    </div>
  )
}

export default Series
